import * as typography from 'assets/styles/typography'
import styled from 'styled-components'

export const Title = styled.h3`
    ${typography.Copy20}
    font-weight: 700;
    margin-bottom: 10px;
    margin-top: 0px;
`

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    border-bottom: 1px solid
        ${(props) => props.theme.colors.monochrome.concrete};
    margin-top: 5px;
    margin-bottom: 20px;
`
export const ContentContainer = styled.div`
    width: 100%;
    display: block;
`

export const MainContainer = styled.div`
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
`
